import { authRoles } from "../../../auth/authRoles";
import Data from "./Data/Data";
import EditData from "./Data/EditData";
import TambahData from "./Data/TambahData";
import EditKategori from "./Kategori/EditKategori";
import Kategori from "./Kategori/Kategori";
import TambahKategori from "./Kategori/TambahKategori";

const komiteGCGRoutes = [
  {
    path: "/kategori_komite/edit/:id",
    exact: true,
    component: EditKategori,
    auth: authRoles.all,
  },
  {
    path: "/kategori_komite/tambah",
    exact: true,
    component: TambahKategori,
    auth: authRoles.all,
  },
  {
    path: "/kategori_komite",
    exact: true,
    component: Kategori,
    auth: authRoles.all,
  },
  {
    path: "/data_komite/edit/:id",
    exact: true,
    component: EditData,
    auth: authRoles.all,
  },
  {
    path: "/data_komite/tambah",
    exact: true,
    component: TambahData,
    auth: authRoles.all,
  },
  {
    path: "/data_komite",
    exact: true,
    component: Data,
    auth: authRoles.all,
  },
];

export default komiteGCGRoutes;
